/**
 * A collection's membership is applied by the search endpoint, from `?collection=<slug>`. The
 * client only ever holds the user's own narrowing within it.
 */
import { Paths } from "client/routes";
import { DEFAULT_PAGE_SIZE } from "client/products/constants/filterDefinitions";
import { SelectedProductFilters } from "client/products/types";
import { EMPTY_PRODUCT_SELECTION, getProductFiltersFromSearch } from "client/products/utils";

type CollectionSearch = Paths["productCollections"]["detail"]["Search"];

const noSelection = (): SelectedProductFilters => ({ ...EMPTY_PRODUCT_SELECTION });

export const SEARCH_DEFAULTS = {
  q: "",
  page: 1,
  page_size: DEFAULT_PAGE_SIZE,
  sort: "",
  ...noSelection(),
};

/**
 * A collection that hides its filters offers no control, so nothing in the URL may narrow it.
 * Named rather than spread, so a dimension the panel has no control for cannot narrow the grid
 * with no chip to clear it.
 */
export const getSelectedFilters = (
  search: CollectionSearch,
  showFilters: boolean,
): SelectedProductFilters => {
  if (!showFilters) {
    return noSelection();
  }
  const selected = getProductFiltersFromSearch(search);
  return {
    category_ids: selected.category_ids,
    manufacturer_ids: selected.manufacturer_ids,
    species: selected.species,
    prescription_required: selected.prescription_required,
    patient_ids: selected.patient_ids,
    rebate_ids: selected.rebate_ids,
  };
};
